<app-feature-details-grid>
  <app-feature-list-container>
    <app-feature-list-item
      data-at-dry-contact-device-name
      *ngIf="deviceName$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.DEVICE_NAME' | translate }}"
      value="{{ feature | value2: FeaturePropertyKey.name }}"
      [attr.data-feature]="feature.feature"
      [editable]="feature | executable: FeatureCommands.setName"
      (edit)="openEditModal()"
    >
    </app-feature-list-item>
    <app-feature-list-item
      data-at-type-of-connection
      label="{{ '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.TYPE_OF_CONNECTION' | translate }}"
      value="{{ '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.TYPE_OF_CONNECTION_DESCRIBE' | translate }}"
      [valueInfoTooltip]="
        '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.TYPE_OF_CONNECTION_DESCRIBE_TOOLTIP' | translate
      "
    >
    </app-feature-list-item>
    <app-feature-list-item
      data-at-dry-nominal-power
      *ngIf="powerNominal$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.NOMINAL_POWER' | translate }}"
      value="{{ feature | value2: FeaturePropertyKey.value }} {{
        feature | unit: FeaturePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>
